import { generateUtilityClass, generateUtilityClasses } from '../styles/classes';
export var configBlockComponentName = 'QuantumConfigBlock';
export function getConfigBlockUtilityClass(slot) {
    return generateUtilityClass(configBlockComponentName, slot);
}
export var configBlockClasses = generateUtilityClasses(configBlockComponentName, ['root', 'avatar', 'control']);
